
/* eslint-disable */
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'app',
directives: {
TransferDom
},
components: {
Loading
},
data() {
return {
transitionName: '',
isloading: false,
loadingText: ''
};
},
created: function () {







},
watch: {
'$route'(to, from) {
if (to.path === '/') {
this.transitionName = 'slide-right';
} else {
this.transitionName = 'slide-left';
}
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue